var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 8, md: 8, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [_vm._v("Tipo do processo:")]),
              _c(
                "el-select",
                {
                  attrs: {
                    planceholder: "Selecione",
                    "no-match-text": "Nenhum Tipo Encontrado",
                    filterable: "filterable",
                    clearable: "clearable"
                  },
                  model: {
                    value: _vm.filtro.tipo,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "tipo", $$v)
                    },
                    expression: "filtro.tipo"
                  }
                },
                _vm._l(_vm.tiposProcesso, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.nome, value: item.codigo }
                  })
                }),
                1
              )
            ],
            1
          ),
          !_vm.isMA
            ? _c(
                "el-col",
                { attrs: { lg: 8, md: 8, sm: 24 } },
                [
                  _c("p", { staticClass: "label" }, [_vm._v("Status:")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        planceholder: "Selecione",
                        "no-match-text": "Nenhum Status Encontrado",
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      model: {
                        value: _vm.filtro.status,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "status", $$v)
                        },
                        expression: "filtro.status"
                      }
                    },
                    _vm._l(_vm.statusCadastro, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: {
                          label: _vm.getStatusFormatado(item),
                          value: item
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { lg: 8, md: 8, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [_vm._v("Município:")]),
              _c(
                "el-select",
                {
                  attrs: {
                    planceholder: "Selecione",
                    "no-match-text": "Nenhum Status Encontrado",
                    filterable: "filterable",
                    clearable: "clearable"
                  },
                  on: { clear: _vm.resetFilter },
                  model: {
                    value: _vm.filtro.municipio,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "municipio", $$v)
                    },
                    expression: "filtro.municipio"
                  }
                },
                _vm._l(_vm.municipios, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.nome, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 8, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [_vm._v("Nº do processo:")]),
              _c("el-input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: ["#########/####"],
                    expression: "['#########/####']"
                  }
                ],
                model: {
                  value: _vm.filtro.numeroProcesso,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "numeroProcesso", $$v)
                  },
                  expression: "filtro.numeroProcesso"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 8, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(
                    _vm.isIcmBio
                      ? "CPF/CNPJ do interessado ou número do CNUC:"
                      : "CPF/CNPJ do interessado:"
                  )
                )
              ]),
              _c("el-input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: ["###.###.###-##", "##.###.###/####-##"],
                    expression: "['###.###.###-##', '##.###.###/####-##']"
                  }
                ],
                model: {
                  value: _vm.filtro.cpfCnpj,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "cpfCnpj", $$v)
                  },
                  expression: "filtro.cpfCnpj"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(
                    _vm.isIcmBio
                      ? "Nome/Razão Social do Interessado ou nome da Unidade de Conservação:"
                      : "Nome/Razão social do interessado:"
                  )
                )
              ]),
              _c("el-input", {
                model: {
                  value: _vm.filtro.nomeRazaoSocial,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "nomeRazaoSocial", $$v)
                  },
                  expression: "filtro.nomeRazaoSocial"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "button-row" },
        [
          _vm.EXIBIR_OBSERVACAO_CONSULTA_PROCESSOS
            ? _c("p", { staticClass: "observacao" }, [
                _c("span", { staticClass: "atencao" }, [_vm._v("*")]),
                _c("i", [
                  _vm._v(
                    "Essa área de consulta é exclusiva para processos eletrônicos do SiCARF. Caso o seu ainda seja físico, você deverá acessar:"
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "url",
                      attrs: {
                        href:
                          "http://www.iterpa.pa.gov.br/content/consulta-de-processos",
                        target: "_blank"
                      }
                    },
                    [_vm._v(" iterpa.pa.gov.br/content/consulta-de-processos")]
                  )
                ])
              ])
            : _vm._e(),
          _c("span", { staticClass: "limpar", on: { click: _vm.limpar } }, [
            _vm._v("Limpar")
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.consultar } },
            [
              _c("i", { staticClass: "icon fas fa-search" }),
              _vm._v("Consultar")
            ]
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("listagem-processos", {
            attrs: {
              processos: _vm.processos,
              totalItems: _vm.countProcessos,
              page: _vm.filtro.pagina,
              loading: _vm.loadingTable
            },
            on: {
              "update:totalItems": function($event) {
                _vm.countProcessos = $event
              },
              "update:total-items": function($event) {
                _vm.countProcessos = $event
              },
              changePage: _vm.changePage,
              goTo: _vm.goTo
            }
          }),
          _c(
            "el-button",
            {
              staticClass: "right",
              attrs: { type: "text", disabled: _vm.disableExportarCSV },
              on: { click: _vm.exportarCsv }
            },
            [
              _c("i", { staticClass: "fal fa-file-csv" }),
              _vm._v("  Exportar CSV")
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58ddbebf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58ddbebf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/ConsultaGeral.vue
// module id = null
// module chunks = 